export default __webpack_public_path__ + "10009d3f42863db2b6ea2f7267fa5e93.png";